<template>
  <hypto-popup :title="isRetry ? 'Retry Refund' : 'Settle to Hypto'" :footer="formErrors.invalid_credit.length === 0">
    <template v-slot:body>
      <div v-if="formErrors.invalid_credit.length === 0">
        <p v-if="isRetry">Are you sure you want to retry refund for invalid credit <u @click="openTxns">{{id}}</u>?</p>
        <p v-else>Are you sure you want to settle invalid credit <u @click="openTxns">{{id}}</u> to Hypto Account?</p>
      </div>
      <error-info :errorList="formErrors.invalid_credit" class="c-align" />
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="performRefundAction">
        Confirm
      </button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import ErrorInfo from '@/components/global/ErrorInfo'

import VaServices from '@/services/api/vaInvalidCredits'
import UpiServices from '@/services/api/upiInvalidCredits'

export default {
  name: 'RefundConfirmation',
  components: { HyptoPopup, ErrorInfo },
  data () {
    return {
      isRetry: false,
      formErrors: {
        invalid_credit: []
      }
    }
  },
  props: {
    refundAction: String,
    id: Number,
    page: {
      type: String,
      default: 'VA'
    }
  },
  created () {
    this.isRetry = this.refundAction === 'RETRY_REFUND'
  },
  methods: {
    openTxns () {
      this.$emit('openTxns')
    },
    performRefundAction () {
      const ApiServices = this.page === 'UPI' ? UpiServices : VaServices
      ApiServices.refundAction(this.id, {perform: this.refundAction}).then(response => {
        if (response.success) {
          this.successToastMsg(response.message)
          this.$emit('refreshList', response.data)
        } else {
          this.errorToastMsg(response.message)
        }
      }).catch(error => {
        let data = error.body
        this.formErrors = {
          ...this.formErrors,
          ...data.reason
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

 u {
   color: $primary !important;
   cursor: pointer;
   font-weight: 500;
 }
 .c-align {
   display: flex;
   justify-content: center;
 }
</style>
